<template>
  <Transition name="fade-slide">
    <div
      v-if="errors.length > 0"
      ref="summaryRef"
      class="rounded-lg border border-red-200 bg-red-50 p-4"
      role="alert"
      aria-live="assertive"
    >
      <div class="flex items-start gap-3">
        <svg
          class="mt-0.5 h-5 w-5 flex-shrink-0 text-red-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
          />
        </svg>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-semibold text-red-800">
            {{
              errors.length === 1
                ? 'Please fix this error before continuing:'
                : `Please fix these ${errors.length} errors before continuing:`
            }}
          </p>
          <ul class="mt-1.5 list-inside list-disc space-y-0.5 text-sm text-red-700">
            <li v-for="error in errors" :key="error.field ?? error.label">
              <span class="font-medium">{{ error.label }}:</span> {{ error.message }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, watch, nextTick } from 'vue'

export interface ValidationErrorItem {
  field?: string
  label: string
  message: string
}

const props = defineProps<{
  errors: ValidationErrorItem[]
}>()

const summaryRef = ref<HTMLElement>()

watch(
  () => props.errors.length,
  async (newLen, oldLen) => {
    if (newLen > 0 && oldLen === 0) {
      await nextTick()
      summaryRef.value?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }
)
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
